// extracted by mini-css-extract-plugin
module.exports = {"btn_copy":"copy-module--btn_copy--3p9az"};